import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { FormField } from '@adornis/formfield/form-field.js';
import { LogistikProductTargetAudience } from '@chancenwerk/db/enums/LogistikEnums.js';
import '@chancenwerk/design/components/cr-dropdown-multiselection.js';
import { html } from 'lit';
import { ifDefined } from 'lit-html/directives/if-defined.js';
import { customElement } from 'lit/decorators.js';

const allKeyword = 'Alle';

/**
 * @element logistik-component-target-audience-selector
 */
@customElement('logistik-component-target-audience-selector')
export class LogistikComponentTargetAudienceSelector extends FormField<Maybe<LogistikProductTargetAudience[]>> {
  override render() {
    return html`
      <cr-dropdown-multiselection
        clearable
        ${css({ width: '100%' })}
        placeholder="Zielgruppe"
        .selectables=${[allKeyword].concat(Object.values(LogistikProductTargetAudience))}
        @value-picked=${(e: ValueEvent<Maybe<LogistikProductTargetAudience[]>>) => {
          if (e.detail.value?.includes(allKeyword as LogistikProductTargetAudience))
            this.value.next(Object.values(LogistikProductTargetAudience));
          else this.value.next(e.detail.value ?? []);

          this.dispatchEvent(new CustomEvent('value-picked', { detail: { value: this.value.value } }));
        }}
        .value=${this.value.value}
        error=${ifDefined(this.error)}
      ></cr-dropdown-multiselection>
    `;
  }
}
